import { content } from './content';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
function isValidEmail(v) {
  return EMAIL_RE.test(v.trim());
}
function digitsOnly(v) {
  return v.replace(/\D/g, '');
}
function formatPhone(v) {
  const d = digitsOnly(v).slice(0, 10);
  if (d.length === 0) return '';
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
function isValidPhone(v) {
  return digitsOnly(v).length === 10;
}
function isValidDate(v) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
  const d = /* @__PURE__ */ new Date(v + 'T00:00:00');
  if (Number.isNaN(d.getTime())) return false;
  const today = /* @__PURE__ */ new Date();
  today.setHours(0, 0, 0, 0);
  return d <= today && d.getFullYear() > 1900;
}
function validate(values) {
  const e = {};
  const { errors } = content;
  if (!values.patientFirstName.trim()) e.patientFirstName = errors.required;
  if (!values.patientLastName.trim()) e.patientLastName = errors.required;
  if (!values.patientDateOfBirth) e.patientDateOfBirth = errors.required;
  else if (!isValidDate(values.patientDateOfBirth)) e.patientDateOfBirth = errors.date;
  if (!values.completedBy) e.completedBy = errors.required;
  if (values.completedBy === 'proxy') {
    if (!values.proxyFirstName.trim()) e.proxyFirstName = errors.required;
    if (!values.proxyLastName.trim()) e.proxyLastName = errors.required;
    if (!values.proxyEmail.trim()) e.proxyEmail = errors.required;
    else if (!isValidEmail(values.proxyEmail)) e.proxyEmail = errors.email;
    if (!values.proxyPhone.trim()) e.proxyPhone = errors.required;
    else if (!isValidPhone(values.proxyPhone)) e.proxyPhone = errors.phone;
    if (!values.proxyRelationship) e.proxyRelationship = errors.required;
  }
  if (!values.consentChoice) e.consentChoice = errors.required;
  if (!values.signatureDataUrl) e.signatureDataUrl = errors.signature;
  if (values.copyEmail.trim() && !isValidEmail(values.copyEmail)) e.copyEmail = errors.email;
  return e;
}
export { digitsOnly, formatPhone, isValidDate, isValidEmail, isValidPhone, validate };
